export type NumeralKind = 'decimal' | 'duration' | 'integer';
/** Splits display text without changing precision, separators, or leading zeros. */
export function metricNumerals(value: string, kind: NumeralKind): { primary: string; extended: string } {
  const match = kind === 'duration' ? /^(.*:)(\d{2})$/.exec(value)
    : kind === 'decimal' ? /^(.*\.)(\d+)$/.exec(value) : null;
  return match ? { primary: match[1]!, extended: match[2]! } : { primary: value, extended: '' };
}
